import React, { useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import axios from 'axios';
import user from '../../../images/user.jpeg';
import { environment, S3_BUCKET, myBucket, BuildingLink } from '../../../env';
import { getBuildingAction, getGSTAction, getGalaAction, getHSNAction, getProfileImage, getProjectAction, getUserProjectAction, successModalToggle } from '../../../redux/actions/Index';
import { CheckSquareOffset, ClockClockwise, NotePencil, UserPlus } from '@phosphor-icons/react';
import { useEffect } from 'react';
import { UserDataAction, } from './../../../redux/actions/Index';
import SuccessPopups from '../../../components/Popups/SuccessPopups';
import PathName from '../../../components/PathName/PathName';
import { toast } from 'react-toastify';
import ErrorComponents from '../../../components/errorComponents/ErrorComponents';
const Settings = () => {
    const [show, setShow] = useState(true)
    const [pass, setPass] = useState(false)
    const projectList = useSelector((state) => state?.ModalReducer?.projectList);
    const hsn = useSelector((state) => state?.ModalReducer?.hsnData)
    const GST = useSelector((state) => state?.ModalReducer?.gstData)
    const userdata = useSelector((state) => state?.Reducers?.userdata);
    const userProject = useSelector((state) => state?.ModalReducer?.userproject);
    const ProfileImage = useSelector((state) => state?.ModalReducer?.userimg);
    const userid = useSelector((state) => state?.Reducers?.userdata);
    const [passwordToggle2, setPasswordToggle2] = useState(true)
    const [eyeIcon2, setEyeIcon2] = useState('fa-eye');
    const [eyeIcon3, setEyeIcon3] = useState('fa-eye');
    const [psserr, setPsserr] = useState('')
    const [passwordToggle3, setPasswordToggle3] = useState(true)

    let LoggedID = localStorage.getItem('userid')


    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
    } = useForm();

    const {
        register: register1,
        handleSubmit: handleSubmit1,
        reset: reset1,
    } = useForm();

    const dispatch = useDispatch();

    const documenturl = async (data) => {
        var date = Math.round(+new Date() / 1000);
        const params = {
            ACL: "public-read",
            Body: data,
            Bucket: S3_BUCKET,
            Key: `${date}_${data.name}`,
        };
        myBucket.upload(params, function (err, uploadData) {
            if (uploadData) {
                data = uploadData.Location;
                return (data);
            } else {
                console.log("error", err);
            }
        });
    }

    const getProjectData = () => {
        try {
            axios.get(`${environment.baseUrl}project/`).then(res => {
                let data = res.data;
                dispatch(getProjectAction(data));
            }).catch(res => {
                console.log("error", res);
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const getGST = () => {
        try {
            axios.get(`${environment.baseUrl}create-gst`).then(res => {
                dispatch(getGSTAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const getHsn = () => {
        try {
            axios.get(`${environment.baseUrl}create-hsn`).then(res => {
                dispatch(getHSNAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getUserProject = async () => {
        try {
            await axios.get(`${environment.baseUrl}user-project/${LoggedID}`).then(res => {
                let data = res.data;
                dispatch(getUserProjectAction(data.project));
                dispatch(getProfileImage(data.profile_img));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getGalaData = () => {
        try {
            axios.get(`${environment.baseUrl}gala/`).then(res => {
                let data = res.data.filter((data, i) => data?.project.id == userProject)
                dispatch(getGalaAction(data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getBuildingData = () => {
        try {
            axios.get(`${environment.baseUrl}building/`).then(res => {
                dispatch(getBuildingAction(res.data));

            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const filterprojectName = (e) => {
        var projectData = projectList.filter((curVal, i) => {
            if (curVal.id == e.target.value) {
                return curVal
            }
        })
        const payLoad = {
            "project": parseInt(e.target.value),
        }
        try {
            axios.put(`${environment.baseUrl}user-project/${LoggedID}`, payLoad).then((res) => {
                toast.success("Default Project Selected")
                getUserProject()
                getBuildingData()
                getGalaData()
                getProjectData();
            })
        } catch (error) {
            console.log("error:", error)
        }
    }
    const defaultHsn = (e) => {
        var hsnData = hsn.filter((curVal, i) => {
            if (curVal.id == e.target.value) {
                return curVal
            }
        })
        try {
            axios.get(`${environment.baseUrl}default-hsn/${hsnData[0].id}`).then((res) => {
                toast.success("Default HSN Selected")
                getHsn();
            })
        } catch (error) {
            console.log("error:", error)
        }
    }
    const defaultGst = (e) => {
        try {
            axios.get(`${environment.baseUrl}default-gst/${e.target.value}`).then((res) => {
                toast.success("Default Gst Selected")
                getGST();
            })
        } catch (error) {
            console.log("error:", error)
        }
    }

    const UserRegistration = async () => {
        try { await axios.get(`${environment.baseUrl}get-registration/${userdata?.id}`).then(res => dispatch(UserDataAction(res.data))).catch(res => console.log("error", res)) }
        catch (err) {
            console.log(err);
        }
    };

    const Image = async (data) => {
        var date = Math.round(+new Date() / 1000);
        var img = ''
        Array.from(data).forEach(async (file) => {
            img = `${BuildingLink}${date}_${file.name}`
            await documenturl(file)
        })
        const payLoad = {
            "profile_img": img,
        }
        try {
            axios.put(`${environment.baseUrl}user-project/${LoggedID}`, payLoad).then((res) => {
                getUserProject()
                getProjectData();
            })
        } catch (error) {
            console.log("error:", error)
        }
    }

    const submit = async (data) => {
        if (data?.profile_image[0]) {
            Image(data?.profile_image)
        }
        const payLoad = { first_name: data?.first_name, last_name: data?.last_name, email: data?.email, username: userdata?.username, role: userdata?.role }
        try {
            await axios.put(`${environment.baseUrl}editprofile/${userdata?.id}`, payLoad).then(res => {
                if (res.data.code == 200) {
                    dispatch(UserDataAction(res.data));
                    toast.success("Profile update successfully")
                    UserRegistration()
                    setShow(!show)
                }
                else {
                    console.log('error');
                }
            })
        }
        catch (err) {
            console.log("errs", err);
        }
    }

    useMemo(() => {
        reset({
            "first_name": userdata.first_name,
            "last_name": userdata.last_name,
            "email": userdata.email
        })
    }, [show])

    useEffect(() => {
    }, [GST, ProfileImage])

    const submitt = async (data) => {
        console.log(data);
        if (data.fpassword != data.fpassword2) {
            setPsserr("Passwords do not match");
            return
        } else {
            setPsserr('')
        }
        try {
            await axios.post(`${environment.baseUrl}forgot-password/`, data).then((response) => {
                if (response.data.code == 200) {
                    setPass(false)
                    toast.success("Password Updated Successfully")
                }
                else if (response.data.code == 500) {
                    if (response.data.message) {
                        setregistererror(response.data.message)
                    } else if (response.data.message) {
                        setregistererror(response.data.message)
                    } else {
                    }
                }
            })
        }
        catch (err) {
            console.log(err);
        }
    }
    const passwordShow2 = () => {
        setPasswordToggle2(!passwordToggle2);
        if (eyeIcon2 == 'fa-eye') {
            setEyeIcon2("fa-eye-slash");
        } else {
            setEyeIcon2("fa-eye");
        }
    }
    const passwordShow3 = () => {
        setPasswordToggle3(!passwordToggle3);
        if (eyeIcon3 == 'fa-eye') {
            setEyeIcon3("fa-eye-slash");
        } else {
            setEyeIcon3("fa-eye");
        }
    }

    return (
        <>
            <PathName />
            <SuccessPopups />
            <div className="bg-white rounded-5 mb-5 shadow-sm  p-4 p-md-4 p-lg-5 p-xl-5">
                <form onSubmit={handleSubmit(submit)}>
                    <div className='px-3'>
                        <h1 className='title-font-bold py-3 px-2'>User Profile</h1>
                        <div className="basic-details-back-main px-2 py-5 ">
                            <div className="basic-details-back ">
                                <div className="basic-details-user-img  d-flex justify-content-between align-items-center ">
                                    {
                                        show ?
                                            <div className="d-flex align-items-center justify-content-center gap-3">
                                                <div className="basic-details-imgBox">
                                                    <img src={ProfileImage ? ProfileImage : user} alt="user-img" className='user-image-fit' />
                                                </div>
                                                <div className="nameBox d-flex flex-column pt-3 px-3 gap-1">
                                                    <h1 className='fs-1 text-capitalize title-font-700 text-base-color'>{userdata.first_name} {userdata.last_name}
                                                    </h1>
                                                    <h3 className='base-font-600 fw-600 fs-3  text-capitalize text-dark'>{userdata.email}</h3>
                                                    <p className='title-font-500 fs-3  mb-0 text-capitalize '>{userdata?.role == 'superadmin' && 'SuperAdmin' || userdata?.role == 'admin' && 'Admin' || userdata?.role == 'user' && 'user'}</p>
                                                </div>
                                            </div> :
                                            <>
                                                <div className="d-flex align-items-center justify-content-center gap-4">
                                                    <div className="basic-details-imgBox position-relative">
                                                        {/* {
                                                        file ?
                                                            <img src={file} className='user-image-fit' />
                                                            :
                                                            <img src={props.basicdetails.profile_pic ? `${environment.imageUrl}${props.basicdetails.profile_pic}` : `${defaultimage}`} alt="user-img" className='user-image-fit' />

                                                    } */}
                                                        <img src={ProfileImage ? ProfileImage : user} className='user-image-fit' />
                                                        <div className="upload-img-main">
                                                            <label htmlFor="file-input">
                                                                <UserPlus size="40" variant="Bulk" className='upload-img-icon p-2' />
                                                            </label>
                                                            <div className=''>
                                                                <input
                                                                    id='file-input'
                                                                    type="file"
                                                                    className='opacity-0'
                                                                    {...register("profile_image")}
                                                                    accept="image/jpeg,image/png,image/gif"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="nameBox d-flex flex-column pt-3 px-3 gap-1">
                                                        <div className="d-flex gap-2">
                                                            <div className='col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6  pt-1'>
                                                                <div className="mt-1  d-flex gap-3">
                                                                    <input
                                                                        className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                                        type='text'
                                                                        placeholder='Enter First Name...'
                                                                        {...register("first_name", { required: true })}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className='col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6  pt-1'>
                                                                <div className="mt-1  d-flex gap-3">
                                                                    <input
                                                                        className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                                        type='text'
                                                                        placeholder='Enter Last Name...'
                                                                        {...register("last_name", { required: true })}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1'>
                                                            <div className="mt-1  d-flex gap-3">
                                                                <input
                                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                                    type='email'
                                                                    placeholder='Enter Email...'
                                                                    {...register("email", { required: true })}
                                                                />
                                                            </div>
                                                        </div>
                                                        <p className='title-font-500 fs-3  mb-0 text-capitalize '>{userdata?.role == 'superadmin' && 'SuperAdmin' || userdata?.role == 'admin' && 'Admin' || userdata?.role == 'user' && 'user'}</p>
                                                    </div>
                                                </div>
                                                <button className='buttons d-flex align-items-center px-5 py-3 justify-content-end rounded-3' type='submit'>
                                                    <span className='text-base-600 fs-2'>Save</span>{
                                                        show ? <NotePencil size="34" variant="Bulk" className='ps-2 text-white' /> : <CheckSquareOffset size="34" variant="Bulk" className='ps-2 text-white' />
                                                    }
                                                </button>
                                            </>
                                    }
                                    {show &&
                                        <button className='buttons d-flex align-items-center px-5 py-3 rounded-3' onClick={() => setShow(!show)}>
                                            <span className='text-base-600 fs-2'>{show && "Edit"}</span>{
                                                show ? <NotePencil size="34" variant="Bulk" className='ps-2 text-white' /> : <CheckSquareOffset size="34" variant="Bulk" className='ps-2 text-white' />
                                            }

                                        </button>}
                                    {show &&
                                        <button className='buttons d-flex align-items-center px-5 py-3 rounded-3' onClick={() => { setPass(!pass); reset1({ 'fusername': userdata.username }) }}>
                                            <span className='text-base-600 fs-2'>{show && "Reset Password"}</span>{
                                                show ? <ClockClockwise size="34" variant="Bulk" className='ps-2 text-white' /> : <CheckSquareOffset size="34" variant="Bulk" className='ps-2 text-white' />
                                            }

                                        </button>}
                                </div>
                            </div>
                        </div>

                    </div>
                </form>
                <div className='d-flex'>
                    <div className='col-10 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb- ps-3 pt-1'>
                        <label className="fs-4 title-font-500 mb-0 text-base-color form-label form-label">Default Project Name</label>
                        <br />
                        <div className="mt-1  d-flex gap-3">
                            <select
                                id="role_type"
                                name="role_type"
                                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                {...register("project", { required: true, onChange: (e) => { filterprojectName(e) } })}
                            >
                                <option value="" >Project Name</option>
                                {projectList?.map((data, i) => {
                                    return <option value={data.id} key={i} selected={data.id == userProject}>{data.name}</option>;
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col-10 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 ps-3 pt-1'>
                        <label className="fs-4 title-font-500 mb-0 text-base-color form-label form-label">Default GST</label>
                        <br />
                        <div className="mt-1  d-flex gap-3">
                            <select
                                id="role_type"
                                name="role_type"
                                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                {...register("gst", { required: true, onChange: (e) => { defaultGst(e) } })}
                            >
                                <option value="" >GST ( % )</option>
                                {GST?.map((gst, i) => {
                                    return <option value={gst.id} key={i} selected={gst.default == true}>{gst.percentage} % </option>;
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col-10 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 ps-3 pt-1'>
                        <label className="fs-4 title-font-500 mb-0 text-base-color form-label form-label">Default HSN Number</label>
                        <br />
                        <div className="mt-1  d-flex gap-3">
                            <select
                                id="role_type"
                                name="role_type"
                                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                {...register("hsn", { required: true, onChange: (e) => { defaultHsn(e) } })}
                            >
                                <option value="" >HSN Number</option>
                                {hsn?.map((data, i) => {
                                    return <option value={data.id} key={i} selected={data.default == true}>{data.number}</option>;
                                })}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            {pass && <>
                <div className="bg-white rounded-5 mb-5 shadow-sm  p-4 p-md-4 p-lg-5 p-xl-5">
                    <form onSubmit={handleSubmit1(submitt)}>
                        <h1 className='title-font-bold py-3 px-2'>Reset Password</h1>

                        <div className='d-flex row'>
                            <div className='col-10 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb- ps-3 pt-1'>
                                <label className="fs-4 title-font-500 mb-0 text-base-color form-label form-label">Username *</label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <input
                                        id="role_type"
                                        type='text'
                                        disabled
                                        name="role_type"
                                        className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        {...register1("fusername", { required: true })}
                                    />
                                </div>
                            </div>
                            <br />
                            <div className='col-10 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 ps-3 pt-1'>
                                <label className="fs-4 title-font-500 mb-0 text-base-color form-label form-label">Password *</label>
                                <br />
                                <div className="position-relative d-flex align-items-center w-100">
                                    <input type={passwordToggle3 ? "password" : "search"}
                                        {...register1("fpassword", { required: true })}
                                        placeholder="Enter New Password..."
                                        id="fpassword"
                                        name="fpassword"
                                        className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                    />
                                    <span className="eye-box" onClick={() => passwordShow3()}>
                                        {
                                            eyeIcon3 !== "fa-eye" ?
                                                <i className="fa-regular fa-eye fs-3 text-base-gray"></i> :
                                                <i className="fa-regular fa-eye-slash fs-3 text-base-gray" ></i>
                                        }
                                    </span>
                                </div>
                            </div>
                            <div className='col-10 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 ps-3 pt-1'>
                                <label className="fs-4 title-font-500 mb-0 text-base-color form-label form-label">Confirm Password *</label>
                                <br />
                                <div className="position-relative d-flex align-items-center w-100">
                                    <input
                                        type={passwordToggle2 ? "password" : "search"} id='fpassword2'
                                        {...register1("fpassword2", {
                                            required: true,
                                        })}
                                        placeholder="Re-type Password"
                                        className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                    />
                                    <span className="eye-box" onClick={() => passwordShow2()}>
                                        {
                                            eyeIcon2 !== "fa-eye" ?
                                                <i className="fa-regular fa-eye fs-3 text-base-gray"></i> :
                                                <i className="fa-regular fa-eye-slash fs-3 text-base-gray" ></i>
                                        }
                                    </span>
                                </div>
                                {psserr && <ErrorComponents error={psserr} />}
                                {errors.fpassword2 && <ErrorComponents error={errors.fpassword2?.message} />}
                            </div>
                            <div className='col-10 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 ps-3 pt-1'>
                                <label className="fs-4 title-font-500 mb-0 text-base-color form-label form-label " style={{ opacity: 0 }}>Confirm Password *</label>
                                <br />
                                <button className='buttons d-flex align-items-center px-5 py-3 rounded-3' type='submit'>
                                    <span className='text-base-600 fs-2'>{show && "Save"}</span>{<CheckSquareOffset size="34" variant="Bulk" className='ps-2 text-white' />
                                    }
                                </button>
                            </div>
                        </div>

                    </form>
                </div>
            </>}
        </>
    )
}

export default Settings